<template>
  <div class="grid">
    <div class="col-12">
      <Card>
        <template #title>Закрытие лимита</template>
        <template #content>
          <LimitSearchForm
            ref="searchForm"
            loan-action="close"
          />
        </template>
      </Card>
    </div>
  </div>
</template>

<script>
import LimitSearchForm from "@/components/Forms/LimitSearchForm.vue";

export default {
  name: "CloseLimit",
  components: { LimitSearchForm },
  methods: {
  }
}
</script>